import appGlobalScript from '/usr/src/git2rpm/root-3fd7400a-e90e-4739-8a56-4b32a3c24b43/tmp/topdir/BUILD/townnews-webcomponent-1.22.0/src/global/app.ts';
export const globalScripts = appGlobalScript;
